module.exports = __webpack_public_path__ + "static/media/image_65.d23b3855.png";